import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {RadiographyResultModel} from '../../models/radiography-result.model';
import {Injectable} from '@angular/core';
import {RadiographySearchQueryModel} from '../../models/radiography-search-query.model';

@Injectable()
export class RadiographyService {
  basePath = 'imaging-report/';

  constructor(private apiService: ApiService) {

  }

  getRadiography(query: RadiographySearchQueryModel): Observable<RadiographyResultModel> {
    return this.apiService.post(this.basePath, query);
  }


}
